import { ScrollToModule } from 'ng2-scroll-to-el';
import { BackArrowComponent } from './components/back-arrow/back-arrow.component';
import { TopBannerComponent } from './components/top-nav-banner/top-banner.component';
import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
import { RouterModule } from '@angular/router';
import { CenterMenuComponent } from './components/navigation/center-menu/center-menu.component';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [TapToTopComponent, CenterMenuComponent, LoaderComponent, ModalDialogComponent, TopBannerComponent, BackArrowComponent],
  exports: [
    LoaderComponent,
    CenterMenuComponent,
    TapToTopComponent,
    ModalDialogComponent,
    TopBannerComponent,
    BackArrowComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    ScrollToModule
  ]
})
export class SharedModule { }
